import type { GetWeavePopNotificationByType } from '@frontend/types';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

type Props = {
  onView: (notification: GetWeavePopNotificationByType<'task-center'>) => void;
};

export const useTaskCenterNotification = ({ onView }: Props) => {
  const { create, remove } = useNotification<'task-center'>();
  useCommonActionSubscriptions('task-center');

  useNotificationActionSubscription(
    'task-center',
    'view',
    (_e) => {
      onView(_e.notification);
      //TODO: move the onClick logic here
      // e.notification.payload.onClick?.();
    },
    [onView]
  );

  return {
    create,
    remove,
  };
};
